export default __webpack_public_path__ + "static/media/depth_first_traversal.4a801200.jpg";